import { useEffect } from 'react';
import { userLogoutRequest } from '../actions/auth';
import { useAppDispatch } from '../hooks';
import LoginForm from './LoginForm';

export default function Logout() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(userLogoutRequest());
  }, [dispatch]);

  return <LoginForm loggedOut />;
}
